import {
  SIGN_UP_BEGIN,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAILED,
} from "../actions/signupactions";

const initialState = {
  loading: false,
  signUpError: null,
};

export function signUpReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);
  switch (action.type) {
    case SIGN_UP_BEGIN:
      nextState.loading = true;
      return nextState;
    case SIGN_UP_SUCCESS:
      nextState.loading = false;
      return nextState;
    case SIGN_UP_FAILED:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
